import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  headerContainer: {
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 1),
    },
  },
  programItemHeader: {},
  groupWrapper: {
    ...theme.mixins.appContainer,
    padding: theme.spacing(2, 0),
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1, 0),
    },
  },
  linkWrapper: {
    ...theme.mixins.appLink,
  },
  setWrapper: {
    padding: theme.spacing(0, 2),
    '&:not(:first-of-type)': {
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 1),
    },
  },
  programItemTitle: {
    flex: 1,
    minWidth: 0,
    textTransform: 'capitalize',
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  supersetDivider: {
    borderTop: `2px solid ${theme.palette.primary.main}`,
    width: '100%',
    margin: theme.spacing(2, 0),
  },
}));
